import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-pb-study-options',
    templateUrl: './pb-study-options.component.html',
    styleUrls: ['./pb-study-options.component.scss']
})
export class PbStudyOptionsComponent implements OnInit {

    @Input() module: any = {};

    waySwiperInstance: any;
    wayIndex: number = 0;
    padding_top: any = '';
    padding_bottom: any = '';
    slides: any = [];

    // A swiper config which is responsive and doesn't show partial slides and only shows 1 slide (typically used for quotes)

    public standardConfig: any = {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true, // Automatically hides pagination when not needed
        pagination: { clickable: true },
        autoplay: { delay: 5000 },
        loop: false,
        breakpoints: {
            576: {
                enabled: false,
                slidesPerView: 4,
                pagination: false,
                autoplay: false
            }
        }
    };

    constructor(
        private api: ApiService,
        private cd: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: object
    ) { }

    ngOnInit(): void {

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchStudyOptions();

    }

    /**
     * When 'Ways you can study' swiper is ready then issue update so that the sizing is correct
     * @param swiper
     */
    onWaySwiper(swiper) {

        this.waySwiperInstance = swiper;

        if (!swiper || !isPlatformBrowser(this.platformId)) {
            return;
        }

        setTimeout(() => {
            if (!swiper.destroyed) {
                swiper.update();
            }
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onWaySlideChange() {

        if (this.waySwiperInstance) {
            this.wayIndex = this.waySwiperInstance.realIndex;

            this.cd.detectChanges();
        }

    }

    /**
     * Slides to the next image
     */
    gotoWay(index: number) {

        this.waySwiperInstance.slideTo(index);

    }

    /**
     * Fetches notice board posts
     */
    async fetchStudyOptions() {

        await this.api.fetch_study_options()
            .subscribe(res => {
                this.slides = res.data.items;
                this.cd.detectChanges();
            }, (err) => {

            });

    }

}
